import Rougena from "./rougena.service";

const rougenaModule = angular
  .module("app.services.rougena", [])
  .service("Rougena", Rougena);

export default rougenaModule;



// WEBPACK FOOTER //
// ./src/services/rougena/rougena.module.js